module.exports = __webpack_public_path__ + "static/media/jw_green.21af0d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/balloons/jw_green.png
// module id = 778
// module chunks = 0